import { useState } from "react";
import moment from "moment";
import customAxios from "../../../../utils/customAxios";

export function useCancelBooking({
    id,
}) {
    const [isFetchingCancelFee, setIsFetchingCancelFee] = useState(false);
    const [cancellationFee, setCancellationFee] = useState(null);

    const [isCancellingBooking, setIsCancellingBooking] = useState(false);
    const [cancelBookingResponse, setCancelBookingResponse] = useState(null);

    const buildSimulationPayload = () => {
        return {
            bookingId: id,
        };
    };

    const handleCancelSimulation = async () => {
        try {
            setIsFetchingCancelFee(true);
            const payload = buildSimulationPayload();
            const response = await customAxios.post(
                "/api/request-change-booking/cancel-booking/simulation",
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            const simulationData = response?.data?.data || response?.data || null;
            setCancellationFee(simulationData);
        } catch (error) {
            console.error(
                "Edit booking simulation failed:",
                error?.response?.data || error
            );
        } finally {
            setIsFetchingCancelFee(false);
        }
    };

    const buildCancelPayload = () => {
        return {
            bookingId: id,
            requestType: "cancel"
        };
    };

    const handleCancelBooking = async () => {
        try {
            setIsCancellingBooking(true);
            const payload = buildCancelPayload();
            const response = await customAxios.post(
                "/api/request-change-booking",
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            const cancelBooking = response?.data?.data || response?.data || null;
            setCancelBookingResponse(cancelBooking);
        } catch (error) {
            console.error(
                "Cancel booking failed:",
                error?.response?.data || error
            );
        } finally {
            setIsCancellingBooking(false);
        }
    };

    return {
        isFetchingCancelFee,
        cancellationFee,
        setIsFetchingCancelFee,
        handleCancelSimulation,
        isCancellingBooking,
        cancelBookingResponse,
        handleCancelBooking,
    };
}
